import React from 'react';
import useGetParsedSchedules from '@components/SchedulePage/utilities/useGetParsedSchedules/useGetParsedSchedules';
import { useFacilitySelection } from '@components/SchedulePage/utilities/useFacilitySelection/useFacilitySelection';

/**
 * This hook is used to get the block info for the selected surgeon, unit and date
 * This hook is an independent utility to get the schedule info for the selected block
 * This hook eliminates the need of ScheduleContext in the BlockReleaseRequestContext
 */

export const useGetBlockInfo = () => {
	const { schedules, setSchedules, getApiBlocksAndProcessForUi } = useGetParsedSchedules(false);
	const { getFacilityByUnit } = useFacilitySelection();

	const getBlockInfo = React.useCallback(
		(npi?: string | number, unit?: string, date?: string) => {
			const selectedNpi = npi && parseInt(npi.toString());
			const selectedFacility = unit && getFacilityByUnit(unit);
			const selectedDate = date && new Date(date);

			if (selectedNpi && selectedFacility && selectedDate) {
				getApiBlocksAndProcessForUi([selectedNpi], selectedFacility, selectedDate);
			}
		},
		[getFacilityByUnit, getApiBlocksAndProcessForUi],
	);

	return { schedules, setSchedules, getBlockInfo };
};
